<script lang="ts" setup>
import { LoaderBlockDomain } from '@shared/ui/loaders'

defineOptions({
  name: 'SkeletonLearningProgress',
})
</script>

<template>
  <div class="skeleton-learning-progress">
    <LoaderBlockDomain />
  </div>
</template>

<style scoped lang="scss" src="./SkeletonLearningProgress.scss" />
